import React, { useState } from 'react';
import { useAuthStore } from '../store';
import { translations } from '../translations';

// Challenges activos para el usuario
const activeChallenges = [
  {
    id: 1,
    name: 'Semana Wellness',
    description: 'Completa 4 sesiones de entrenamiento esta semana',
    type: 'WEEKLY',
    icon: '💪',
    reward: 'Upgrade Circuito Recovery',
    progress: 3,
    goal: 4,
    daysLeft: 2,
    joined: true,
    participants: 156
  },
  {
    id: 2,
    name: 'Runner Caldea',
    description: 'Acumula 15km corriendo en enero',
    type: 'MONTHLY',
    icon: '🏃',
    reward: 'Pack Recovery Premium',
    progress: 11.2,
    goal: 15,
    daysLeft: 4,
    joined: true,
    participants: 89
  },
  {
    id: 3,
    name: 'Balance Mental',
    description: 'Completa 5 sesiones de breathwork',
    type: 'MONTHLY',
    icon: '🧘',
    reward: 'Quiet Hour VIP',
    progress: 2,
    goal: 5,
    daysLeft: 4,
    joined: false,
    participants: 67
  },
  {
    id: 4,
    name: 'Circuito Completo',
    description: 'Usa gym + spa + relax esta semana',
    type: 'WEEKLY',
    icon: '🏔️',
    reward: 'Hidratación + Descarga',
    progress: 2,
    goal: 3,
    daysLeft: 2,
    joined: true,
    participants: 112
  }
];

// Logros desbloqueados
const achievements = [
  { id: 1, name: 'Primera Sesión', icon: '⭐', date: '2026-01-05', description: 'Completaste tu primer entrenamiento' },
  { id: 2, name: 'Racha de 7 días', icon: '🔥', date: '2026-01-15', description: 'Entrenaste 7 días seguidos' },
  { id: 3, name: 'Recovery Master', icon: '💆', date: '2026-01-20', description: 'Canjeaste 5 rewards de recovery' },
  { id: 4, name: 'Early Bird', icon: '🌅', date: '2026-01-22', description: 'Entrenaste antes de las 8am' }
];

// Leaderboard
const leaderboard = [
  { rank: 1, name: 'Carlos P.', improvementScore: 245, avatar: '👨' },
  { rank: 2, name: 'Tú', improvementScore: 125, avatar: '👩', isUser: true },
  { rank: 3, name: 'Ana L.', improvementScore: 118, avatar: '👩‍🦰' },
  { rank: 4, name: 'Pedro M.', improvementScore: 105, avatar: '🧔' },
  { rank: 5, name: 'Laura S.', improvementScore: 98, avatar: '👱‍♀️' },
];

export default function ChallengesPage() {
  const [activeTab, setActiveTab] = useState('active');
  const { language } = useAuthStore();
  const t = translations[language];

  const getProgressPercent = (progress, goal) => Math.min((progress / goal) * 100, 100);

  return (
    <div className="max-w-7xl mx-auto px-4 py-8 dark:text-gray-100">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-4xl font-bold mb-2 dark:text-white">{t.challengesTitle}</h1>
        <p className="text-gray-600 dark:text-gray-400">{t.challengesSubtitle}</p>
      </div>

      {/* Stats rápidas */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
        <div className="bg-white dark:bg-gray-800 p-5 rounded-xl shadow-lg border-l-4 border-cyan-500">
          <div className="text-gray-500 dark:text-gray-400 text-sm">{t.activeChallenges}</div>
          <div className="text-3xl font-bold text-cyan-600">3</div>
        </div>
        <div className="bg-white dark:bg-gray-800 p-5 rounded-xl shadow-lg border-l-4 border-green-500">
          <div className="text-gray-500 dark:text-gray-400 text-sm">{t.completed}</div>
          <div className="text-3xl font-bold text-green-600">2</div>
        </div>
        <div className="bg-white dark:bg-gray-800 p-5 rounded-xl shadow-lg border-l-4 border-purple-500">
          <div className="text-gray-500 dark:text-gray-400 text-sm">{t.achievements}</div>
          <div className="text-3xl font-bold text-purple-600">4</div>
        </div>
        <div className="bg-white dark:bg-gray-800 p-5 rounded-xl shadow-lg border-l-4 border-amber-500">
          <div className="text-gray-500 dark:text-gray-400 text-sm">{t.ranking}</div>
          <div className="text-3xl font-bold text-amber-600">#2</div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* Challenges */}
        <div className="lg:col-span-2">
          {/* Tabs */}
          <div className="flex gap-4 mb-6 border-b dark:border-gray-700">
            <button 
              className={`pb-3 px-4 font-semibold ${activeTab === 'active' ? 'border-b-2 border-cyan-600 text-cyan-600 dark:text-cyan-400 dark:border-cyan-400' : 'text-gray-500 dark:text-gray-400'}`}
              onClick={() => setActiveTab('active')}
            >
              {t.tabMyChallenges}
            </button>
            <button 
              className={`pb-3 px-4 font-semibold ${activeTab === 'available' ? 'border-b-2 border-cyan-600 text-cyan-600 dark:text-cyan-400 dark:border-cyan-400' : 'text-gray-500 dark:text-gray-400'}`}
              onClick={() => setActiveTab('available')}
            >
              {t.tabAvailable}
            </button>
            <button 
              className={`pb-3 px-4 font-semibold ${activeTab === 'achievements' ? 'border-b-2 border-cyan-600 text-cyan-600 dark:text-cyan-400 dark:border-cyan-400' : 'text-gray-500 dark:text-gray-400'}`}
              onClick={() => setActiveTab('achievements')}
            >
              {t.tabAchievements}
            </button>
          </div>

          {activeTab !== 'achievements' && (
            <div className="space-y-4">
              {activeChallenges
                .filter(c => activeTab === 'active' ? c.joined : !c.joined)
                .map((challenge) => (
                <div key={challenge.id} className="bg-white dark:bg-gray-800 rounded-xl shadow-lg p-6">
                  <div className="flex items-start gap-4">
                    <div className="text-4xl">{challenge.icon}</div>
                    <div className="flex-1">
                      <div className="flex justify-between items-start mb-2">
                        <div>
                          <h3 className="text-xl font-bold dark:text-white">{challenge.name}</h3>
                          <span className={`text-xs px-2 py-1 rounded-full ${
                            challenge.type === 'WEEKLY' ? 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300' : 'bg-purple-100 text-purple-700 dark:bg-purple-900/40 dark:text-purple-300'
                          }`}>
                            {challenge.type === 'WEEKLY' ? t.weekly : t.monthly}
                          </span>
                        </div>
                        <span className="text-sm text-gray-500 dark:text-gray-400">
                          ⏱️ {challenge.daysLeft} {t.timeLeft}
                        </span>
                      </div>
                      
                      <p className="text-gray-600 dark:text-gray-300 mb-4">{challenge.description}</p>

                      {challenge.joined && (
                        <>
                          <div className="mb-2">
                            <div className="flex justify-between text-sm mb-1">
                              <span className="text-gray-500 dark:text-gray-400">{t.progress}</span>
                              <span className="font-semibold dark:text-gray-200">
                                {challenge.progress} / {challenge.goal} 
                                {typeof challenge.progress === 'number' && challenge.progress % 1 !== 0 ? ' km' : ''}
                              </span>
                            </div>
                            <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-3">
                              <div 
                                className={`h-3 rounded-full transition-all ${
                                  getProgressPercent(challenge.progress, challenge.goal) >= 100 
                                    ? 'bg-green-500' 
                                    : 'bg-cyan-500'
                                }`}
                                style={{ width: `${getProgressPercent(challenge.progress, challenge.goal)}%` }}
                              />
                            </div>
                          </div>
                        </>
                      )}

                      <div className="flex justify-between items-center mt-4 pt-4 border-t dark:border-gray-700">
                        <div className="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
                          <span>👥 {challenge.participants} {t.participants}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <span className="text-sm text-green-600 dark:text-green-400 font-semibold">
                            🎁 {challenge.reward}
                          </span>
                          {!challenge.joined && (
                            <button className="bg-cyan-600 text-white px-4 py-2 rounded-lg font-semibold hover:bg-cyan-700 transition dark:bg-cyan-700 dark:hover:bg-cyan-600">
                              {t.join}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              ))}
            </div>
          )}

          {activeTab === 'achievements' && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {achievements.map((achievement) => (
                <div key={achievement.id} className="bg-white rounded-xl shadow-lg p-5 flex items-center gap-4">
                  <div className="text-4xl">{achievement.icon}</div>
                  <div>
                    <h3 className="font-bold">{achievement.name}</h3>
                    <p className="text-sm text-gray-600">{achievement.description}</p>
                    <p className="text-xs text-gray-400 mt-1">{achievement.date}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Sidebar - Leaderboard */}
        <div>
          <div className="bg-white rounded-xl shadow-lg p-6 sticky top-4">
            <h3 className="text-xl font-bold mb-4 flex items-center gap-2">
              🏅 Top 5 Enero
            </h3>
            <div className="space-y-3">
              {leaderboard.map((user) => (
                <div 
                  key={user.rank} 
                  className={`flex items-center gap-3 p-3 rounded-lg ${user.isUser ? 'bg-cyan-50 border-2 border-cyan-500' : 'bg-gray-50'}`}
                >
                  <div className={`text-lg font-bold w-8 ${user.rank <= 3 ? 'text-amber-500' : 'text-gray-400'}`}>
                    #{user.rank}
                  </div>
                  <div className="text-2xl">{user.avatar}</div>
                  <div className="flex-1">
                    <div className={`font-semibold ${user.isUser ? 'text-cyan-600' : ''}`}>
                      {user.name} {user.isUser && '(Tú)'}
                    </div>
                  </div>
                  <div className="font-bold text-cyan-600">Nivel {user.improvementScore}</div>
                </div>
              ))}
            </div>

            <div className="mt-6 p-4 bg-gradient-to-r from-cyan-500 to-blue-600 rounded-xl text-white">
              <p className="text-sm font-semibold mb-2">💡 Consejo</p>
              <p className="text-sm opacity-90">
                Completa "Semana Wellness" para ganar 20 niveles extra y subir al #1
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
